// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"50dca819","402":"ea044937","428":"56c8bf37","488":"5d2f02b9","599":"d1549b00"}[chunkId] + ".chunk.js";
};